document.addEventListener( 'DOMContentLoaded', function () {
	const config = window.SweettySpaceContactsPhone || {};
	const roots = Array.from( document.querySelectorAll( '[data-contacts-form]' ) );

	if ( ! roots.length || typeof window.intlTelInput !== 'function' ) {
		return;
	}

	function getPhoneInputs( root ) {
		return Array.from(
			root.querySelectorAll(
				'input[type="tel"], input.wpcf7-tel, .wpcf7-tel input'
			)
		).filter( function ( input ) {
			return input instanceof HTMLInputElement;
		} );
	}

	function initPhoneInput( input, root ) {
		if ( input.dataset.contactsPhoneReady === 'true' ) {
			return;
		}

		const defaultCountry =
			( root.getAttribute( 'data-default-country' ) || config.defaultCountry || 'ua' )
				.toString()
				.toLowerCase();

		const instance = window.intlTelInput( input, {
			initialCountry: defaultCountry,
			preferredCountries: [ 'ua' ],
			showFlags: true,
			separateDialCode: true,
			nationalMode: false,
			autoPlaceholder: 'aggressive',
			formatOnDisplay: true,
			strictMode: false,
		} );

		input.dataset.contactsPhoneReady = 'true';
		input._ssIntlTelInput = instance;

		const itiRoot = input.closest( '.iti' );

		if ( itiRoot ) {
			if ( config.flags1xUrl ) {
				itiRoot.style.setProperty(
					'--iti-path-flags-1x',
					'url("' + config.flags1xUrl + '")'
				);
			}

			if ( config.flags2xUrl ) {
				itiRoot.style.setProperty(
					'--iti-path-flags-2x',
					'url("' + config.flags2xUrl + '")'
				);
			}
		}

		const form = input.form || root.querySelector( 'form' );

		if ( form && ! form.dataset.contactsPhoneSubmitBound ) {
			form.addEventListener( 'submit', function () {
				getPhoneInputs( root ).forEach( function ( field ) {
					if ( field._ssIntlTelInput ) {
						field.value = field._ssIntlTelInput.getNumber() || field.value;
					}
				} );
			} );

			form.dataset.contactsPhoneSubmitBound = 'true';
		}
	}

	function initRoot( root ) {
		getPhoneInputs( root ).forEach( function ( input ) {
			initPhoneInput( input, root );
		} );
	}

	roots.forEach( initRoot );

	document.addEventListener( 'wpcf7invalid', function () {
		roots.forEach( initRoot );
	} );

	document.addEventListener( 'wpcf7mailfailed', function () {
		roots.forEach( initRoot );
	} );
} );
